var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var PostControllerQuiz = {
    /*****************************************************************************************************
        * Is using route "api/post/CorrelatePairsQuestion" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {CorrelatePairsQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {CorrelatePairsQuestionDownloadDto}
    ******************************************************************************************************/
    PostCorrelatePairsQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/CorrelatePairsQuestion", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/CorrelatePairsQuestion/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {CorrelatePairsQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {CorrelatePairsQuestionDownloadDto}
    ******************************************************************************************************/
    PatchCorrelatePairsQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/CorrelatePairsQuestion/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/EstimateQuestion" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {EstimateQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @returns {EstimateQuestionDownloadDto}
    ******************************************************************************************************/
    PostEstimateQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/EstimateQuestion", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/EstimateQuestion/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {EstimateQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @returns {EstimateQuestionDownloadDto}
    ******************************************************************************************************/
    PatchEstimateQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/EstimateQuestion/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/FourPicturesOneSolutionQuestion" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {File} media1
        * @param {File} media2
        * @param {File} media3
        * @param {FourPicturesOneSolutionQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @returns {FourPicturesOneSolutionQuestionDownloadDto}
    ******************************************************************************************************/
    PostFourPicturesOneSolutionQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        if (data.media1)
            fd.append("media1", data.media1);
        if (data.media2)
            fd.append("media2", data.media2);
        if (data.media3)
            fd.append("media3", data.media3);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/FourPicturesOneSolutionQuestion", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/FourPicturesOneSolutionQuestion/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {File} media1
        * @param {File} media2
        * @param {File} media3
        * @param {FourPicturesOneSolutionQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @returns {FourPicturesOneSolutionQuestionDownloadDto}
    ******************************************************************************************************/
    PatchFourPicturesOneSolutionQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        if (data.media1)
            fd.append("media1", data.media1);
        if (data.media2)
            fd.append("media2", data.media2);
        if (data.media3)
            fd.append("media3", data.media3);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/FourPicturesOneSolutionQuestion/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/MarkInPictureQuestion" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {MarkInPictureQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @returns {MarkInPictureQuestionDownloadDto}
    ******************************************************************************************************/
    PostMarkInPictureQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/MarkInPictureQuestion", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/MarkInPictureQuestion/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {MarkInPictureQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @returns {MarkInPictureQuestionDownloadDto}
    ******************************************************************************************************/
    PatchMarkInPictureQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/MarkInPictureQuestion/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/MarkAreaInPictureQuestion" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {MarkAreaInPictureQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {MarkAreaInPictureQuestionDownloadDto}
    ******************************************************************************************************/
    PostMarkAreaInPictureQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/MarkAreaInPictureQuestion", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/MarkAreaInPictureQuestion/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {MarkAreaInPictureQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {MarkAreaInPictureQuestionDownloadDto}
    ******************************************************************************************************/
    PatchMarkAreaInPictureQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/MarkAreaInPictureQuestion/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/MultipleChoiceQuestion" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {MultipleChoiceQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {MultipleChoiceQuestionDownloadDto}
    ******************************************************************************************************/
    PostMultipleChoiceQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/MultipleChoiceQuestion", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/MultipleChoiceQuestion/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {MultipleChoiceQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {MultipleChoiceQuestionDownloadDto}
    ******************************************************************************************************/
    PatchMultipleChoiceQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/MultipleChoiceQuestion/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/SortQuestion" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {SortQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {SortQuestionDownloadDto}
    ******************************************************************************************************/
    PostSortQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/SortQuestion", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/SortQuestion/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {SortQuestionUploadDto} data
        * @param {File} prefixExplanation
        * @param {File} postfixCorrectExplanation
        * @param {File} postfixWrongExplanation
        * @param {{[key: string]: File}} answer
        * @returns {SortQuestionDownloadDto}
    ******************************************************************************************************/
    PatchSortQuestion: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.prefixExplanation)
            fd.append("prefixExplanation", data.prefixExplanation);
        if (data.postfixCorrectExplanation)
            fd.append("postfixCorrectExplanation", data.postfixCorrectExplanation);
        if (data.postfixWrongExplanation)
            fd.append("postfixWrongExplanation", data.postfixWrongExplanation);
        _.forEach(data.answer, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/SortQuestion/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/Quiz" and http method "POST" to call the back-end.
    
        * @param {QuizUploadDto} data
        * @returns {QuizDownloadDto}
    ******************************************************************************************************/
    PostQuiz: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Quiz", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/Quiz/{quizid}" and http method "PATCH" to call the back-end.
    
        * @param {string} quizid
        * @param {QuizUploadDto} data
        * @returns {QuizDownloadDto}
    ******************************************************************************************************/
    PatchQuiz: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Quiz/{quizid}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerQuiz.js.map